<template>
  <v-card flat color="transparent">
    <v-card-text>
      <span class="title text-md-center">Rezanie</span>
      <v-layout wrap>
        <v-flex xs12 sm12 md6>
          <v-container fluid grid-list-md pa-0>
            <v-layout row wrap class="pt-3">
              <v-flex xs12>
                <v-text-field
                  v-validate="'required'"
                  v-model="productItem.name"
                  :error-messages="errors.collect('name')"
                  data-vv-as="Názov dielca"
                  data-vv-name="name"
                  name="name"
                  label="Názov dielca"
                ></v-text-field>
              </v-flex>

              <v-flex xl3 lg6 md6 sm6 xs6>
                <v-text-field
                  v-validate="'required'"
                  v-model="changeThickness"
                  :error-messages="errors.collect('thickness')"
                  data-vv-as="Hrúbka"
                  data-vv-name="thickness"
                  :disabled="true"
                  name="thickness"
                  label="Hrúbka"
                  suffix="mm"
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-checkbox label="Dupla" v-model="productItem.duplex"></v-checkbox>
              </v-flex>

              <v-flex xl3 lg6 md6 sm6 xs6>
                <v-text-field
                  v-validate="'required|min_value:1'"
                  v-model.number="productItem.quantity"
                  :error-messages="errors.collect('quantity')"
                  data-vv-as="počet kusov"
                  data-vv-name="quantity"
                  name="quantity"
                  label="Počet kusov"
                  suffix="ks"
                  mask="###"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-checkbox v-model="productItem.rotate" color="error">
                  <template v-slot:label>
                    <span class="error--text">Povoliť otáčanie</span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-validate="`required|decimal:1|max_value:${maxWidth}`"
                  v-model.number="productItem.width"
                  :error-messages="errors.collect('width')"
                  data-vv-as="dĺžka"
                  data-vv-name="width"
                  name="width"
                  label="Dĺžka"
                  suffix="mm"
                  hint="v smere vlakien materialu"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-validate="`required|decimal:1|max_value:${maxHeight}`"
                  v-model.number="productItem.height"
                  :error-messages="errors.collect('height')"
                  data-vv-as="Šírka"
                  data-vv-name="height"
                  name="height"
                  label="Šírka"
                  suffix="mm"
                  hint="kolmo na vlakna materialu"
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  v-validate
                  v-model="productItem.description"
                  :error-messages="errors.collect('description')"
                  data-vv-as="Poznámka"
                  data-vv-name="description"
                  name="description"
                  label="Poznámka"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

        <v-flex xs12 sm12 md6>
          <CuttingMaterial :product="productItem" v-on:selectedMaterial="materialChange()" />
          <CuttingImage :edge="productItem.edge" :material="productItem.material" />
        </v-flex>
      </v-layout>

      <v-divider class="my-4"></v-divider>

      <span class="title text-md-center">Hranenie</span>
      <v-container grid-list-md pa-0>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <CuttingEdge :product="productItem" property="back" :edges="edges" label="Hrana vzadu" />
            <!-- <v-divider class="my-2"></v-divider> -->
            <CuttingEdge
              :product="productItem"
              property="front"
              :edges="edges"
              label="Hrana vpredu"
            />
          </v-flex>
          <v-flex xs12 sm6>
            <CuttingEdge :product="productItem" property="left" :edges="edges" label="Hrana vľavo" />
            <!-- <v-divider class="my-2"></v-divider> -->
            <CuttingEdge
              :product="productItem"
              property="right"
              :edges="edges"
              label="Hrana vpravo"
            />
          </v-flex>
        </v-layout>
      </v-container>

      <v-divider class="my-4"></v-divider>

      <v-layout wrap>
        <v-flex xs12 class="text-xs-right">
          <v-btn color="primary" dark @click.native="save">Uložiť</v-btn>
          <v-btn color="primary" dark @click.native="newItem">Nová doska</v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import CuttingImage from "@/views/cutting/components/CuttingImage";
import CuttingService from "@/services/CuttingService";
import CuttingEdge from "@/views/cutting/components/CuttingEdge";
import CuttingMaterial from "@/views/cutting/components/CuttingMaterial";
import Controller from "@/mixins/controlsMixins";
import * as types from "@/store/types";
import CuttingObject from "@/views/cutting/js/cuttingObject";
export default {
  name: "CuttingModul",
  components: {
    CuttingImage,
    CuttingEdge,
    CuttingMaterial
  },
  mixins: [Controller],
  data() {
    return {
      productItem: null,
      decors: [],
      edges: [],
      maxWidth: 2800,
      maxHeight: 2070,
      isLoading: false,
      search: null,
      doneTypingInterval: 1000,
      typingTimer: null,
      isEdit: false
    };
  },
  created() {
    this.newItem();
  },
  methods: {
    materialChange() {
      //let reg = /.*\s(.*)\/(.*)\/(.*)/gim;
      //let result = reg.exec(this.productItem.material.fullName);
      this.maxWidth =
        this.productItem.material != null
          ? this.getMaxWidth(this.productItem.material)
          : 0;
      this.maxHeight =
        this.productItem.material != null
          ? this.getMaxHeight(this.productItem.material)
          : 0;
      this.productItem.thickness =
        this.productItem.material != null
          ? this.productItem.material.thickness
          : 0;
      console.info(this.productItem.material.thickness);

      new CuttingService()
        .getDecorsHmSearch(
          this.productItem.material.storageCardId,
          this.productItem.duplex
            ? this.productItem.material.thickness * 2
            : this.productItem.material.thickness
        )
        .then(response => {
          console.log(response.data);
          this.edges = response.data;
        })
        .catch(() => {
          this.edges = [];
        });
    },

    getMaxWidth(material) {
      if (material.materialType == "Pracovná doska") {
        return material.width;
      } else {
        return material.width - 30;
      }
    },
    getMaxHeight(material) {
      if (material.materialType == "Pracovná doska") {
        return material.height;
      } else {
        return material.height - 30;
      }
    },

    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.productItem.material == null) {
            this.openGlobalAlert("Vyberte si materiál", "warning");
            return;
          }
          if (
            this.$store.getters.cuttingItems.some(
              e => e.name === this.productItem.name
            )
          ) {
            this.openGlobalAlert("Názov dielca už existuje", "warning");
            return;
          }

          this.$store.commit("removeOptimizationItems");

          this.productItem.decorId = parseInt(
            this.productItem.material.storageCardId
          );
          this.productItem.edgeFrontDecorId =
            this.productItem.edge.front != null
              ? parseInt(this.productItem.edge.front.id)
              : null;
          this.productItem.edgeBackDecorId =
            this.productItem.edge.back != null
              ? parseInt(this.productItem.edge.back.id)
              : null;
          this.productItem.edgeLeftDecorId =
            this.productItem.edge.left != null
              ? parseInt(this.productItem.edge.left.id)
              : null;
          this.productItem.edgeRightDecorId =
            this.productItem.edge.right != null
              ? parseInt(this.productItem.edge.right.id)
              : null;
          this.$store.commit(types.ADD_ITEM_TO_STORE, this.productItem);
          this.newItem();
          this.openGlobalAlert("Položka bola uložená", "success");
          this.$validator.reset();
        }
      });
    },
    newItem() {
      localStorage.removeItem("lastEdgeMaterial");
      let material;
      let rotate;
      if (this.productItem != null) {
        material = this.productItem.material;
        rotate = this.productItem.rotate;
      }
      this.productItem = new CuttingObject();
      this.productItem.name =
        this.productItem.name +
        " " +
        (this.$store.getters.cuttingItems.length + 1);

      this.productItem.material = material;
      this.productItem.rotate = rotate;
      this.productItem.thickness = material == null ? 18 : material.thickness;
      this.productItem.id = (((1 + Math.random()) * 0x10000) | 0)
        .toString(16)
        .substring(1);
    },
    editItem(item) {
      this.productItem = item;
      this.materialChange();
    },
    findDecor(val) {
      if (this.isLoading || this.isEdit || val === "" || val === null) {
        this.isEdit = false;
        return;
      }

      console.log(val);

      this.isLoading = true;

      new CuttingService()
        .getDecorsSearch(val)
        .then(r => {
          console.log(r.data);
          this.decors = r.data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  computed: {
    changeThickness() {
      return this.productItem.duplex == true
        ? this.productItem.thickness * 2
        : this.productItem.thickness;
    }
  },
  watch: {
    search(val) {
      if (val == null) {
        return;
      }
      if (this.productItem.material != null) {
        if (val == this.productItem.material.fullName) return;
      }

      window.clearTimeout(this.typingTimer);

      this.typingTimer = setTimeout(
        () => this.findDecor(val),
        this.doneTypingInterval
      );
    }
  }
};
</script>

<style>
</style>